/**
 * Dashboard Layout
 *
 * Sidebar-based layout with responsive behavior:
 * - Desktop (>=1024px): static sidebar + main content side-by-side
 * - Mobile (<1024px): MobileTopBar + overlay sidebar on hamburger toggle
 *
 * Both sidebar and main content scroll independently (h-screen container).
 */

import { useState } from "react";
import { Outlet } from "react-router";
import { Sidebar } from "../components/nav/Sidebar";
import { MobileTopBar } from "../components/nav/MobileTopBar";

export function DashboardLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="h-screen bg-bg-primary flex flex-col lg:flex-row overflow-hidden">
      {/* Mobile top bar — hidden on desktop */}
      <MobileTopBar onMenuToggle={() => setMobileOpen((prev) => !prev)} />

      {/* Sidebar — fixed overlay on mobile, static on desktop */}
      <Sidebar
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      {/* Main content area — scrolls independently */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
